var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.showMain)?_c('WbList',{staticStyle:{"height":"100%"},attrs:{"grouptreeProp":_vm.grouptreeProp,"changeView":_vm.changeView}}):_vm._e(),(!_vm.showMain)?_c('AddAccount',{attrs:{"grouptreeProp":_vm.grouptreeProp,"changeView":_vm.changeView,"groupId":_vm.curGroupId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }